export const METER_POINT_ID_LENGTH = 14
